<template>
<!-- 选对小工具-个人中心 -->
  <div class="xd-person">
      <!-- head -->
      <div class="head">
        <img class="userImg" :src="info.headimgurl" alt="">
        <div class="text">{{info.nickname}}</div>
      </div>
      <!-- conent -->
      <div class="content">
          <a v-if="consultantBool" @click="$router.push('/xd_money')" class="li">
            <img class="icon" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/money.png" alt="">
            <span class="money">金额</span>
            <img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
          </a>
          <a v-if="consultantBool" @click="bindPhoneHandle()" class="li">
            <img class="icon" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/phone.png" alt="">
            <span class="money">绑定手机号</span>
            <img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
          </a>
          <a v-if="!consultantBool" class="li">
            <img class="icon" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/info.png" alt="">
            <span class="money">基本资料</span>
            <img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
          </a>
      </div>
      <!-- footer toolbar -->
      <div class="footer-toolbar">
          <div class="child" @click="$router.push('/xd_consult')">
              <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/message.png" alt="">
              <p>我的咨询</p>
          </div>
          <div class="child">
              <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/user-icon-on.png" alt="">
              <p>个人资料</p>
          </div>
      </div>
      <!-- 绑定手机号 -->
        <div  :class="['bind-input',bindingPhone?'on':'']">
            <van-field v-if="timeBool" v-model="phone" center clearable label="绑定手机号"  placeholder="请输入手机号">
                <template #button>
                    <van-button @click="getCodeHandle()" size="small" type="primary">发送验证码</van-button>
                </template>
            </van-field>
            <van-field v-else v-model="code" center clearable label="验证码"  placeholder="请输入验证码">
                <template #button>
                    <van-button @click="saveBindPhone()" size="small" type="primary">绑定</van-button>
                </template>
            </van-field>
        </div>
  </div>
</template>

<script>
import { shareCon } from "@/utils/wxconfig";
import { deepCopy,setSessionStorage,getSessionStorage } from "@/utils/tools";
import { phoneValidation } from "@u/validation";
import { orderList,userInfo,check_bind,bind_mobile,send_sms,check_sms } from "@/api/xuandui_gadgets"
export default {
    data(){
        return{
            info:{},
            consultantBool:false,
            // 绑定手机号
            bindingPhone:false,
            // 是否已绑定
            bindPhone:false,
            phone:null,
            code:null,
            sms_id:null,
            // 定时
            timeClock:{},
            timeBool:true

        }
    },
    methods:{
        // 获取验证码
        getCodeHandle(){
            if(!phoneValidation(this.phone)){
                this.$toast('手机号格式不正确！');
                return
            }
            send_sms({
                mobile:this.phone
            }).then((data)=>{
                if(data.error>0){
                    this.$toast(data.msg);
                    return
                }
                this.$forceUpdate();
                this.timeBool = false;
                this.sms_id = data.sms_id;
                
            });
        },
        // 倒计时
        // sendCode(msg){
        //     let timer_num = 10;
        //     this.timeClock = setInterval(()=>{
        //         timer_num--;
        //         if (timer_num == 0) {
        //             clearInterval(this.timeClock);
        //             this.timeBool = true;
        //         } 
        //     },1000)

        // },
        // 提交绑定的手机号
        saveBindPhone(){
            if(!this.code){
                this.$toast('验证码不正确！');
                return
            }
            if(!this.sms_id){
                this.$toast('信息不正确！请重试');
                this.timeBool = true;
                return
            }
            // 检查验证码是否正确

            bind_mobile({
                sms_id:this.sms_id,
                code:this.code,
                mobile:this.phone
            }).then((data)=>{
                if(data.error>0){
                    this.$toast(data.msg);
                    return
                }
                this.$toast('绑定成功！');
                this.bindPhone = true;
                this.phone = null;
                this.bindingPhone = false;
            });
        },
        // 绑定手机号触发
        bindPhoneHandle(){
            if(this.bindPhone){
                this.$toast('已绑定手机号！');
                return
            }
            this.bindingPhone = true;
        },
        // 转base64
        b64Encode(str) {
            return window.btoa(encodeURIComponent(str));
        },
        b64Decode(str) {
            return decodeURIComponent(window.atob(str));
        },
        // 获取用户信息
        getUserInfo(){
            // 获取用户信息
            userInfo().then((data)=>{
                if(data.error>0){
                    this.$toast(data.msg);
                    return
                }
                let q = this.$route.query;
                this.info = data;
                // 判断是否是咨询师
                if(q.consultant && this.b64Decode(q.consultant)=='zx'){
                    setSessionStorage(this.$route.path,'consultant',q.consultant);
                }
                this.consultantBool = getSessionStorage(this.$route.path,'consultant') && this.b64Decode(getSessionStorage(this.$route.path,'consultant'))=='zx';
            });
        },
        pullData(){
            document.title = '个人资料';
            this.getUserInfo();
            // 检查手机号是否已绑定
            check_bind().then((data)=>{
                this.bindPhone = data;
            });
            shareCon('index',this);
        }
    },
    created(){
        this.pullData();
    }

}
</script>

<style lang="scss" scoped>
.xd-person{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    .head{
        background: url('https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/person-bg.png')center no-repeat;
        background-size: cover;
        height: 426px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top:108px ;
        .userImg{
            width: 140px;
            height: 140px;
            border-radius: 50%;
            border: 2px solid #ffffff;
            margin-bottom: 20px;
        }
        .text{
            font-size: 36px;
            color: #FFFFFF;
            font-weight: 400;
        }
    }
    .content{
        width:100%;
        background: #FFFFFF;
        border-radius: 60px 0px 0px 0px;
        flex: 1;
        margin-top: -50px;
        padding: 40px 30px 98px;
        .li{
            display: flex;
            align-items: center;
            font-size: 32px;
            color: #2B333A;
            line-height: 98px;
            font-weight: 400;
            .icon{
                width: 48px;
                margin-right: 10px;
            }
            .right{
                width: 24px;
                height: 24px;
                margin-left: auto;
            }
        }
    }
    .footer-toolbar{
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        width: 100%;
        max-width: 750px;
        background-color: #FFFFFF;
        height: 98px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 144px;
        text-align: center;
        box-shadow: 0px -4px 16px 0px rgba(0, 0, 0, 0.04);
        .child{
            img{
                width: 48px;
                height: 48px;
            }
            p{
                font-size: 22px;
                font-weight: 400;
                color: #7D8289;
                line-height: 32px;
                text-shadow: 0px -8px 32px rgba(0, 0, 0, 0.04);
            }
        }
    }
    .bind-input{
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        bottom: -100px;
        width: 680px;
        transition: all 1s;
        box-shadow: 0px 5px 15px #dddddd;
        z-index: 998;
    }
    .bind-input.on{
        bottom: 200px;
    }
}
</style>